var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-white backgroundStyle font-bold inline-flex items-center justify-center bg-blue-500 rounded-full",class:[_vm.baseClass, _vm.classContainer]},[_c('img',{class:_vm.imgClass,attrs:{"src":require("@/assets/icons/premium.svg")}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }